import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration, withXhr } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { DashboardModule } from './dashboard/dashboard.module';
import { LandingModule } from './landing/landing.module';
import { HttpErrorInterceptor } from './services/interceptor/http-error/http-error.interceptor';
import { HttpTokenInterceptor } from './services/interceptor/http-token/http-token.interceptor';
import { HttpXsrfInterceptor } from './services/interceptor/http-xsrf/http-xsrf.interceptor';
import { ChangeDetectionInterceptor } from './services/interceptor/change-detection/change-detection.interceptor';
import { SharedModule } from './shared/shared.module';
import { BaseUrlInterceptor } from './services/interceptor/base-url.interceptor';
import { provideAppHighcharts } from './providers/highcharts.provider';
import { DataService } from './services/data/data.service';

// Load keys from encrypted-data.json before app starts
export function loadEncryptedData(dataService: DataService) {
  return () => firstValueFrom(dataService.getEncryptedData());
}

// @NgModule({ declarations: [
//         AppComponent,
//     ],
//     bootstrap: [AppComponent], imports: [BrowserModule,
//         BrowserAnimationsModule,
//         AppRoutingModule,
//         LandingModule,
//         DashboardModule,
//         SharedModule], providers: [
//         {
//             provide: HTTP_INTERCEPTORS,
//             useClass: HttpTokenInterceptor,
//             multi: true
//         },
//         {
//             provide: HTTP_INTERCEPTORS,
//             useClass: HttpErrorInterceptor,
//             multi: true,
//         },
//         {
//             provide: HTTP_INTERCEPTORS,
//             useClass: HttpXsrfInterceptor,
//             multi: true
//         },
//         { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
//         provideHttpClient(withInterceptorsFromDi())
//         //  withXsrfConfiguration()withXhr(), 
//     ] })
// export class AppModule { }



@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LandingModule,
    DashboardModule,
    SharedModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadEncryptedData,
      deps: [DataService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpXsrfInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseUrlInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ChangeDetectionInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppHighcharts(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
